import React from 'react'
import "../../styles/s_machine.css"
import Prodcard1 from '../../components/prodcards/Prodcard'
import imgpad from '../../img/printer/padPinter.png'
import imgsc from '../../img/printer/SingleColorPadP.png'
import imgijc from '../../img/printer/InkJetCoder.png'
import imgdryicm from '../../img/printer/Dryibc.jpg'
import imgRibboncm from '../../img/printer/RIBBONcm.jpg'
import imgTIJp from '../../img/printer/TIJp.jpg'



export const Printer = () => {
    const des = {
        imgpad: ['Voltage : 220V/50Hz', 'Power : 180', 'Printing Speed : 100', 'Object Size : 50', 'Dimension : 435*405*560', 'Net Weight : 21',
        ],
        imgsc: ['Dimension - 1075 * 520 *660', 'Weight - 75', 'Printing Area - 85 L * 85 W', 'Power Supply - Ac 220v/50-60Hz', 'Printing Speed - 4200', 'Model - VP SCPP (F)',
        ],
        imgijc: ['Height - 12-7mm', 'Distance - 2-5mm', 'Content - Text,Time', 'Speed - 70m/min', 'Ink Colour - Black,Blue,Red', 'Power Consumption - Less Than 5w', 'Dimension - 120*100*240 mm', 'Weight - 0.8 kg',
        ],
        imgdryicm: ['VOLTAGE-22/50', 'POWER-180', 'PRNTING SPEED-100', 'OBJECT SIE-50-500/30~300', 'PRINTING TYPE-OLID INK CODING', 'DIMENION-440*465*300', 'WEIGHT-26',
        ],
        imgRibboncm: ['VOLTAGE-220/50', 'POWER-2220', 'PRINTING SPEED-0-100', 'COLOR RIBBON WIDTH-35', 'DIMENSION-255*255*325', 'WEIGHT-10', 'MANUAL CODING IS ALSO AVAILABLE',
        ],
        imgTIJp: ['CONTROL PANNEL-TOUCH SCREEN', 'PRINTING SPEED-60M/MIN', 'PRINTING ACCURACY-600DPI', 'HEIGHT-2-12.5MM', 'PRINTING CODE-BAR CODE,QR CODE,DM CODE ETC…', 'PRINTING CONTENT-DATE,TEXT,NUMBER,COUNT NUMBER,CODE ETC…', 'EXTERNAL INTERFACE-USB,PHOTOELECTRIC INTERFACE', 'STORAGE-PRINTER ITSELF OR TRANSFER TO USB DISK'
        ]

    }
    return (
        <div className='prdmain'>
            <div className='head2'>
                <h1>PrinterS</h1>
            </div>
            <div className='items1'>
                <Prodcard1
                    imageSrc={imgpad}
                    model={"VP PP700"}
                    title=" Pad Printer"
                    altText="img of websit"
                    description={des.imgpad}
                />
                <Prodcard1
                    imageSrc={imgsc}
                    model={"no "}
                    title="Single Color Pad Printer (Floor Model Pneumatic)"
                    altText="img of websit"
                    description={des.imgsc}
                />
                <Prodcard1
                    imageSrc={imgijc}
                    model={"VP HIP"}
                    title="Ink Jet Coder"
                    altText="img of websit"
                    description={des.imgijc}
                />
                <Prodcard1
                    imageSrc={imgdryicm}
                    model={"VP 600"}
                    title="DRYING CODING MACHINE"
                    altText="img of websit"
                    description={des.imgdryicm}
                />

                <Prodcard1
                    imageSrc={imgRibboncm}
                    model={"VP 241"}
                    title="RIBBON CODING MACHINE"
                    altText="img of websit"
                    description={des.imgRibboncm}
                />

                <Prodcard1
                    imageSrc={imgTIJp}
                    model={"VP TIJ"}
                    title="TIJ INKJET PRINTER"
                    altText="img of websit"
                    description={des.imgTIJp}
                />

            </div>


        </div>
    )
}
